import { useSelector } from 'react-redux'
import { Navigate, Outlet, useLocation, useMatch } from 'react-router-dom'

import { getLandingRoute } from '../../utils/landingRoute'

const ProtectAuth = () => {
  const user = useSelector((state) => state.user.user)

  const location = useLocation()
  // Matched like the router does (case-insensitive, optional trailing slash)
  const isCompanySelect = useMatch('/selectcompany')

  // Logged-in users may open the company picker to switch company
  if (isCompanySelect && user?.token) return <Outlet />

  // No landing page also covers functions without a page, so /homepage can render for them
  const landingRoute = getLandingRoute(user?.functions)

  return landingRoute ? <Navigate to={landingRoute} state={{ from: location }} replace /> : <Outlet />
}

export default ProtectAuth
